module.exports = __webpack_public_path__ + "img/chargingport_300.9c2ec8db.png";